module.exports = __webpack_public_path__ + "img/logo-head.4213f499.svg";